import type { SxProps, Theme } from '@mui/material/styles';

/** Primary outlined 44×44 icon `Button` (page header, dashboard, flyouts, widgets). */
export const mobilePrimaryDatePickerButtonSx: SxProps<Theme> = {
  minWidth: 44,
  minHeight: 44,
  width: 44,
  height: 44,
  p: 0,
  px: 0,
  py: 0,
  borderWidth: 2,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
};

export const pageHeaderDatePickerTextFieldSx: SxProps<Theme> = (theme) => ({
  '& .MuiPickersOutlinedInput-root': {
    height: 44,
    minHeight: 44,
    maxHeight: 44,
    padding: theme.spacing(0, 1.5),
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: 'none',
    borderRadius: '8px',
    '&:hover': {
      borderColor: theme.palette.primary.dark,
    },
    '&.Mui-focused': {
      borderColor: theme.palette.primary.main,
    },
    '& .MuiPickersInputBase-sectionsContainer': {
      color: theme.palette.primary.main,
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
  },
  '& .MuiPickersOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.primary.main,
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.primary.main,
  },
});

export const widgetNarrowDateRangeButtonSx: SxProps<Theme> = {
  minHeight: 44,
  height: 44,
  px: 1.5,
  py: 0,
  gap: 1,
  borderWidth: 2,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',
};
